export default "__VITE_ASSET__b58fb32b__"